import React from "react";
import { motion } from "framer-motion";
import InventoryOverview from "./InventoryOverview";
import RecentMessages from "./RecentMessages";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import AvailableAddOns from "./AvailableAddOns";

const DashboardMainContent = ({
  inventory,
  messages,
  variants,
  isLoading,
  onRefreshInventory
}) => {
  return (
    <motion.div
      className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:px-8 overflow-hidden"
      variants={variants}
    >
      <div className="lg:col-span-2 space-y-6">
        {isLoading && inventory?.length === 0 ? (
          <Card className="min-h-[386px] flex items-center justify-center">
            <CardContent className="text-center">
              <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto mb-4" />
              <p className="text-muted-foreground">Loading Inventory...</p>
            </CardContent>
          </Card>
        ) : (
          <InventoryOverview
            inventory={inventory}
            onRefreshInventory={onRefreshInventory}
          />
        )}
        {/* <AvailableAddOns /> */}
      </div>
      <div className="lg:col-span-1">
        <RecentMessages />
      </div>
    </motion.div>
  );
};

export default DashboardMainContent;
